import { useQuery, useMutation } from '@tanstack/react-query'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'
import { SearchLogsFilterParams } from '@/types/search-log'
import { useSearchLogsStore } from '@/store'

export const useSearchLogs = (params: SearchLogsFilterParams) => {
  const fetchSearchLogs = useSearchLogsStore(state => state.fetchSearchLogs)

  return useQuery({
    queryKey: ['search-logs', params],
    queryFn: () => fetchSearchLogs(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useSearchLog = (id: string) => {
  const getSearchLog = useSearchLogsStore(state => state.getSearchLog)

  return useQuery({
    queryKey: ['search-log', id],
    queryFn: () => getSearchLog(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })
}

export const useDeleteSearchLog = () => {
  const deleteSearchLog = useSearchLogsStore(state => state.deleteSearchLog)

  return useMutation({
    mutationFn: (id: string) => deleteSearchLog(id),
    onSuccess: () => {}
  })
}

export const useBulkDeleteSearchLogs = () => {
  const bulkDeleteSearchLogs = useSearchLogsStore(state => state.bulkDeleteSearchLogs)
  const deselectAllSearchLogs = useSearchLogsStore(state => state.deselectAllSearchLogs)
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteSearchLogs(ids),
    onSuccess: response => {
      deselectAllSearchLogs()
      handleBulkDeleteSuccess(response)
    }
  })
}
